import request from "root/js/request";

export const getBloggersPostsSelectionBrands = async ({
  source__in,
  item__in,
  subject__in = item__in,
  account_name_hash__in,
  product_id__in,
  limit,
  offset,
  search,
  ...rest
}) => {
  const response = await request({
    url: `parsers/social/posts/brands/`,
    method: "get",
    params: {
      source__in,
      item__in,
      subject__in,
      account_name_hash__in,
      product_id__in,
      limit,
      offset,
      search,
      ...rest,
    },
  });
  return response;
};
